import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import Watermark from './assets/js/warterMark'

NProgress.configure({ showSpinner: false })

// 权限判断
function hasPermission(perms, permissions) {
  console.log(perms,permissions)
  if (perms.indexOf('*') >= 0) return true // 直接传递的管理权限
  if (!permissions) return true
  return perms.some(perm => permissions.indexOf(perm) >= 0) // 删除没有权限的管理
}

const whiteList = ['/login', '/auth-redirect']// 白名单

router.beforeEach((to, from, next) => {
  NProgress.start() // 进度条
  if (getToken()) {
    /*有token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (store.getters.perms.length === 0) { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetUserInfo').then(res => { // 拉取user_info
          console.log(res,'拉取user_info')
          const perms = res.data.perms // note: perms必须是数组: ['GET /aaa','POST /bbb']
          store.dispatch('GenerateRoutes', { perms }).then(() => { // 根据perms权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,设置replace: true，这样导航就不会留下历史记录
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || '验证失败，请重新登录')
            next({ path: '/' })
          })
        })
      } else {
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        if (hasPermission(store.getters.perms, to.meta.perms)) {
          next()
        } else {
          next({ path: '/401', replace: true, query: { noGoBack: true }})
        }
        // 可删 ↑
      }
    }
  } else {
    /* 没有token*/
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
  // Watermark.set(store.getters.name) // 加水印
})



// WEBPACK FOOTER //
// ./src/permission.js